function medals_Reducer(state = [], action) {
    switch (action.type) {
        case 'MEDALS/SET':
            return action.medals;
        case 'MEDALS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default medals_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/medals.js